module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-f59b48565bb639a0a2e46be978a35d07.jpg";